<template>
    <div class="div-reply">
        <v-row justify="start" align="center">
            <div class="scrolling-wrapper-template">
                <v-col cols="4" v-for="(item, index) in preview_data" :key="index" align="center" justify="center">
                    <v-img height="110px" :src="item.value" v-if="extension(item.name) === 'image'">
                        <v-app-bar flat color="rgba(0, 0, 0, 0)">
                            <v-spacer></v-spacer>
                            <v-btn color="red" icon small @click="deleteFile(index)">
                                <v-icon>fa-solid fa-circle-xmark</v-icon>
                            </v-btn>
                        </v-app-bar>
                    </v-img>
                    <v-row v-else style="height: 140px; width: 200px;" class="justify-center">
                        <v-col cols="9" align="center">
                            <v-icon color="white" class="fz-110">
                                {{extension(item.name)}}
                            </v-icon>
                            <p class="white--text mb-0 text-overflow">{{ item.name }}</p>
                        </v-col>
                        <v-col cols="3" align="end">
                            <v-btn color="red" icon small @click="deleteFile(index)">
                                <v-icon>fa-solid fa-circle-xmark</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <p class="white--text mb-0 text-overflow" v-if="extension(item.name) === 'image'">{{ item.name }}</p>
                </v-col>
            </div>
        </v-row>
    </div>
</template>
<script>
export default {
    props: {
        statemember: String,
        preview_data: Array,
        preview_status: Boolean,
    },
    data() {
        return {
            publicPath: process.env.VUE_APP_BASE_PATH,
            stylechat: {
                "--Chat-Background": "white",
                "--Chat-HeaderColor": "white",
                "--Chat-HeaderBackground": "#2463af",
                "--Chat-HeaderPictureBorderRadius": "6px",
                "--Chat-ChatboxBackgroundOwner": "#34567f",
                "--Chat-ChatboxColorOwner": "white",
                "--Chat-ChatboxBorderOwner": "none",
                "--Chat-ChatboxBorderRadiusOwner": "6px",
                "--Chat-ChatboxColorNotSupportOwner": "#929292",
                "--Chat-ChatboxBackgroundOther": "#efefef",
                "--Chat-ChatboxColorOther": "#615f5f",
                "--Chat-ChatboxBorderOther": "none",
                "--Chat-ChatboxBorderRadiusOther": "6px",
                "--Chat-ChatboxColorNotSupportOther": "#b1b1b1",
                "--Chat-TypingboxBackground": "#2463af",
                "--Chat-TypingboxColor": "white",
                "--Chat-QuickReplyButtonBorder": "#2463af",
                "--Chat-QuickReplyButtonBackground": "white",
                "--Chat-QuickReplyButtonColor": "#2463af",
                "--Chat-Icon-Active": "white",
                "--Chat-Template-Btn-Color": "#1976d2"
            },
        }
    },
    watch: {
        preview_data() {
            // console.log("preview_data", this.preview_data);
            if (this.preview_data.length === 0) {
                this.$emit('emitMessage', { methods: 'close-preview', value: false })
            } else {
                this.$emit('emitMessage', { methods: 'update-preview', value: false, item: this.preview_data })
            }
        },
    },
    created() {
        // console.log("statemember =>", this.statemember);
        // console.log("preview_data => ", this.preview_data);
    },
    methods: {
        deleteFile(index) {
            this.preview_data.splice(index, 1)
        },
        extension(path) {
            var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
            var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
            var pdf = ['pdf']
            var spreadsheet = ['xls', 'xlsx', 'xlt', 'xlsm', 'xlm', 'xlsm']
            var presentation = ['ppt', 'pps', 'pot', 'pptx']
            var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
            var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
            var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
            var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4']
            var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
            if (pdf.includes(extension)) {
                return 'fas fa-file-alt'
            } else if (archive.includes(extension)) {
                return 'fas fa-file-archive'
            } else if (spreadsheet.includes(extension)) {
                return 'fas fa-file-excel'
            } else if (presentation.includes(extension)) {
                return 'fas fa-file-powerpoint'
            } else if (word.includes(extension)) {
                return 'fas fa-file-word'
            } else if (execution.includes(extension)) {
                return 'fas fa-file-code'
            } else if (image.includes(extension)) {
                return 'image'
            } else if (media.includes(extension)) {
                return 'media'
            } else if (audio.includes(extension)) {
                return 'fa-solid fa-file-audio'
            } else {
                return 'fas fa-file-alt'
            }
        },
    },
}
</script>
<style scoped>
>>>.v-toolbar__content {
    align-items: flex-start;
    display: flex;
    position: relative;
    z-index: 0;
}
.fz-110 {
    font-size: 110px !important;
}
.scrolling-wrapper-template {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
}

.scrolling-wrapper-template::-webkit-scrollbar {
    height: 10px;
    width: 8px;
    cursor: pointer;
}

.scrolling-wrapper-template::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: rgba(0, 0, 0, .1);
}

>>>.v-image__image {
    border-radius: 12px !important;
}

.text-overflow {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 12vw;
}

.div-reply {
    height: 150px;
    background-color: rgba(0, 0, 0, 0.9);
    padding: 10px;
    bottom: 11px;
    position: relative;
}

.color-white {
    color: white;
}

.imgProfilechat {
    height: 40px;
    vertical-align: middle;
}

.pictureRoomChat {
    border-radius: var(--Chat-HeaderPictureBorderRadius) !important;
}

.alligator-turtle {
    object-fit: cover;
    object-position: 50% 0;
}
</style>